<template>
  <div class="b-modal">
    <button
      v-rtg-tooltip="$t('close')"
      class="btn btn-link modal-close-button"
      data-i18n="close"
      @click="$emit('close')"
    >
      <i-cross
        filled
        :font-controlled="false"
        alt="close"
      />
    </button>
    <div
      v-if="loading && !error"
      class="text-center"
    >
      <div class="spinner-grow text-primary" />
    </div>
    <div
      v-if="error"
      class="alert alert-danger mt-6"
      data-i18n="serverError"
    >
      {{ $t('serverError') }}
    </div>
    <InfoFlight
      v-if="flighttrip && !loading"
      :flight-offer="flightOffer"
      :overnight-gothenburg="overnightGothenburg"
      :overnight-malmo="overnightMalmo"
      :possible-pickups="possiblePickups"
      :luggage-policies="luggagePolicies"
      :trip="trip"
    />
    <InfoBus
      v-if="!flighttrip && !loading"
      :overnight-gothenburg="overnightGothenburg"
      :overnight-malmo="overnightMalmo"
      :possible-pickups="possiblePickups"
      :train-malmo-home="trainMalmoHome"
      :train-malmo-out="trainMalmoOut"
      :trip="trip"
    />
  </div>
</template>

<script setup>
const { trip } = defineProps({
  trip: {
    type: Object,
    required: true,
  },
})

defineEmits(['close'])

const {
  $sentryCaptureMessage,
  $sentrySetContext,
  $sentryCaptureException,
} = useNuxtApp()

const rootStore = useRootStore()
const localeStore = useLocaleStore()

const loading = ref(true)
const error = ref(false)

const flighttrip = ref(false)
const flightOffer = ref(null)

const luggagePolicies = ref(null)

const outbound = ref(false)
const outboundmo = ref(false)

const possiblePickups = ref([])
const trainMalmoHome = ref({})
const trainMalmoOut = ref({})

const overnightGothenburg = computed(() => {
  if (!outbound.value) {
    return []
  }

  const p = []

  Object.keys(outbound).forEach(o => p.push(outbound[o]))

  return p
})

const overnightMalmo = computed(() => {
  if (!outboundmo.value) {
    return []
  }

  const p = []

  Object.keys(outboundmo).forEach(o => p.push(outboundmo[o]))

  return p
})

onBeforeMount(async () => {
  try {
    const { data } = await apiFetch(`/${localeStore.locale}/tripinfo/${trip.tripid}`)
    if (data.error) {
      $sentrySetContext('data',{
        trip,
        details: data,
      })
      $sentryCaptureMessage('tripinfo error', {
        level: 'warning',
        tags: {
          type: 'UX',
        },
      })

      error.value = true
      return
    }

    loading.value = false
    flighttrip.value = data.flighttrip

    if (data.flighttrip) {
      flightOffer.value = data.flightOffer
      luggagePolicies.value = data.luggage_policies

      if (data.airport_dictionary) {
        const airportNames = {}

        data.airport_dictionary.forEach((a) => {
          airportNames[a.iata] = a
        })

        rootStore.SET_CHARTER_AIRPORT_NAMES(airportNames)
      }
    }

    if (data.connecting_journey.outbound && data.connecting_journey.outbound.bussgot) {
      outbound.value = data.connecting_journey.outbound.bussgot.rows
    }
    if (data.connecting_journey.outbound && data.connecting_journey.outbound.bussmmo) {
      outboundmo.value = data.connecting_journey.outbound.bussmmo.rows
    }

    possiblePickups.value = data.possible_pickups

    if (data.connecting_journey.homebound && data.connecting_journey.homebound.train_malmo) {
      trainMalmoHome.value = data.connecting_journey.homebound.train_malmo.rows
    }
    if (data.connecting_journey.outbound && data.connecting_journey.outbound.train_malmo) {
      trainMalmoOut.value = data.connecting_journey.outbound.train_malmo.rows
    }
  } catch (e) {
    $sentryCaptureException(e)
    error.value = true
  }
})
</script>
